import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhoSection() {
  return <Section background="white" data-id="element-63">
      <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-64">
        <div data-id="element-65">
          <h3 className="text-xl font-bold text-[#1e3a5f] mb-4 flex items-center" data-id="element-66">
            <CheckCircle2 className="w-5 h-5 text-green-500 mr-2" data-id="element-67" />
            Es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-68">
            {["Sientes que la pantalla se volvió el 'centro' de la casa", 'Quieres recuperar autoridad sin violencia', 'Estás dispuesto(a) a aguantar incomodidad al inicio para ganar paz después'].map((item, i) => <li key={i} className="flex items-start text-[#2d3748] text-sm" data-id="element-69">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2 mt-2" data-id="element-70"></span>
                <span className="flex-1" data-id="element-71">{item}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-72">
          <h3 className="text-xl font-bold text-[#1e3a5f] mb-4 flex items-center" data-id="element-73">
            <XCircle className="w-5 h-5 text-[#dc4a3d] mr-2" data-id="element-74" />
            No es para ti si:
          </h3>
          <ul className="space-y-3" data-id="element-75">
            {['Buscas una solución mágica sin sostener límites', 'Quieres que el niño cambie pero tú no quieres cambiar nada en el entorno', "Quieres que 'alguien más' lo arregle por ti"].map((item, i) => <li key={i} className="flex items-start text-[#2d3748] text-sm" data-id="element-76">
                <span className="w-1.5 h-1.5 bg-[#dc4a3d] rounded-full mr-2 mt-2" data-id="element-77"></span>
                <span className="flex-1" data-id="element-78">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}